export default __webpack_public_path__ + "static/media/totp.1804a153.svg";